import { BrowserRouter, Routes, Route } from 'react-router-dom';

/* import internal modules */
import Dashboard from '../components/Dashboard/Dashboard';
import Warehouses from '../components/Warehouses/index.constants';
import NewWarehouse from '../components/Warehouses/NewWarehouse.constants';
import EditWarehouse from '../components/Warehouses/EditWarehouse.constants';
import Drawers from '../components/Drawers/index.constants';
import NewDrawer from '../components/Drawers/NewDrawer.constants';
import EditDrawer from '../components/Drawers/EditDrawer.constants';
import Properties from '../components/Properties';
import NewProperty from '../components/Properties/NewProperty';
import EditProperty from '../components/Properties/EditProperty.constants';
import Housekeys from '../components/Housekeys/index.constants';
import NewHousekey from '../components/Housekeys/NewHousekey.constants';
import EditHousekey from '../components/Housekeys/EditHousekey.constants';
import Loans from '../components/Loans';
import Protected from './Protected';
import Users from '../components/Users/index.constants';
import EditUser from '../components/Users/EditUser';
import NewUser from '../components/Users/NewUser';
import Repayments from '../components/Repayments/index.constants';
import Login from '../components/Auth/Login';
import NewLoan from '../components/Loans/NewLoan.constants';
import { useSelector } from 'react-redux';
import { Register } from '../components/Auth/Register';
import { SystemActions } from '../domain/constants/SystemActions';
import { RolePermissions } from '../domain/constants/RolePremissions';
import { NewLoansP2P } from '../components/Loans_p2p/LoansP2PNew/index.constants';
import { LoansP2PList } from '../components/Loans_p2p/LoansP2PList/index.constants';
import ForgotPassword from 'src/components/Auth/ForgotPassword';
import { ReturnHome } from 'src/components/Repayments/home/index.constants';

type routeProps = {
  path: string;
  component: any;
  permissionsName: string;
};

const Router = () => {
  const user = useSelector(({ auth }: any) => auth.token);
  const type = useSelector(({ auth }: any) => auth.type);

  const routeList: routeProps[] = [
    {
      path: '/warehouses',
      component: <Warehouses />,
      permissionsName: SystemActions.read_warehouses,
    },
    {
      path: '/warehouses/new',
      component: <NewWarehouse />,
      permissionsName: SystemActions.create_warehouses,
    },
    {
      path: '/warehouses/edit/:id',
      component: <EditWarehouse />,
      permissionsName: SystemActions.edit_warehouses,
    },
    {
      path: '/drawers',
      component: <Drawers />,
      permissionsName: SystemActions.read_drawers,
    },
    {
      path: '/drawers/new',
      component: <NewDrawer />,
      permissionsName: SystemActions.create_drawers,
    },
    {
      path: '/drawers/edit/:id',
      component: <EditDrawer />,
      permissionsName: SystemActions.edit_drawers,
    },
    {
      path: '/properties',
      component: <Properties />,
      permissionsName: SystemActions.read_properties,
    },
    {
      path: '/properties/new',
      component: <NewProperty />,
      permissionsName: SystemActions.create_properties,
    },
    {
      path: '/properties/edit/:id',
      component: <EditProperty />,
      permissionsName: SystemActions.edit_properties,
    },
    {
      path: '/housekeys',
      component: <Housekeys />,
      permissionsName: SystemActions.read_keys,
    },
    {
      path: '/housekeys/new',
      component: <NewHousekey />,
      permissionsName: SystemActions.create_keys,
    },
    {
      path: '/housekeys/edit/:id',
      component: <EditHousekey />,
      permissionsName: SystemActions.edit_keys,
    },
    {
      path: '/p2p/loans',
      component: <LoansP2PList />,
      permissionsName: SystemActions.read_loans_p2p,
    },
    {
      path: '/p2p/loans/new',
      component: <NewLoansP2P />,
      permissionsName: SystemActions.create_loans_p2p,
    },
    {
      path: '/loans',
      component: <Loans />,
      permissionsName: SystemActions.read_loans_by_session,
    },
    {
      path: '/loans/new',
      component: <NewLoan />,
      permissionsName: SystemActions.create_loans,
    },
    {
      path: '/users',
      component: <Users />,
      permissionsName: SystemActions.read_users,
    },
    {
      path: '/users/edit/:id',
      component: <EditUser />,
      permissionsName: SystemActions.edit_users,
    },
    {
      path: '/users/new',
      component: <NewUser />,
      permissionsName: SystemActions.create_users,
    },
    {
      path: '/repayments',
      component: <ReturnHome />,
      permissionsName: SystemActions.edit_loans,
    },
    {
      path: '/repayments/new',
      component: <Repayments />,
      permissionsName: SystemActions.edit_loans,
    },
  ];

  return (
    <BrowserRouter>
      <Routes>
        {routeList?.map(({ path, permissionsName, component }, i) => (
          <Route
            key={`route-key-${i}`}
            path={path}
            element={
              <Protected
                isAuth={
                  user &&
                  RolePermissions.allowed(
                    Number(type),
                    permissionsName as SystemActions
                  )
                }
              >
                {component}
              </Protected>
            }
          />
        ))}
        <Route
          element={
            <Protected isAuth={user}>
              <Dashboard />
            </Protected>
          }
          path='/'
        />
        <Route element={<Login />} path='/login' />
        <Route element={<Register />} path='/register' />
        <Route element={<ForgotPassword />} path='/forgot-password' />
        <Route
          path='/*'
          element={
            <Protected isAuth={user}>
              <Dashboard />
            </Protected>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
